import { fillBar, type SessionFill } from "@teamna/shared";
import { FillBarTrack } from "../fill-bar.tsx";

/**
 * How full one session is (Studio Home, H1): "4 of 6 booked", a bar, and the people who wait and
 * who come for the first time, and the health notes (C2: a count, never the answers). The words come from `sessionFill` in `@teamna/shared`, which the
 * phone reads too. A session with no limit has no bar.
 */
export function FillMeter({ fill, className = "" }: { fill: SessionFill; className?: string }) {
  const extras = [fill.waitingText, fill.firstTimersText].filter((text): text is string => text !== null);
  const bar = fillBar(fill);
  return (
    <div className={`flex min-w-0 flex-col gap-1.5 ${className}`}>
      <p className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px]">
        <span className={`font-semibold ${fill.full ? "text-confirmed-ink" : "text-ink"}`}>{fill.full ? `Full, ${fill.text}` : fill.text}</span>
        {extras.map((text) => (
          <span key={text} className="rounded-pill bg-accent-surface px-2 py-0.5 text-[12px] font-bold text-accent-strong">
            {text}
          </span>
        ))}
        {fill.healthNotesText ? (
          <span className="rounded-pill bg-late-surface px-2 py-0.5 text-[12px] font-bold text-late-ink">{fill.healthNotesText}</span>
        ) : null}
      </p>
      {/* The words above say the same, so the bar is hidden from a screen reader. One colour, gold when people wait (D38). */}
      {bar ? <FillBarTrack bar={bar} className="h-1.5 rounded-full bg-sunken" /> : null}
    </div>
  );
}
